"use client";
import { rem } from "../../../core/utils/units-converters/rem.mjs";
import { createVarsResolver } from "../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { useStyles } from "../../../core/styles-api/use-styles/use-styles.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import ActionIcon_module_default from "../ActionIcon.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/ActionIcon/ActionIconGroup/ActionIconGroup.tsx
const defaultProps = { orientation: "horizontal" };
const varsResolver = createVarsResolver((_, { borderWidth }) => ({ group: { "--ai-border-width": rem(borderWidth) } }));
const ActionIconGroup = factory((_props) => {
	const props = useProps("ActionIconGroup", defaultProps, _props);
	const { className, style, classNames, styles, unstyled, orientation, vars, borderWidth, variant, mod, attributes, ...others } = props;
	return /* @__PURE__ */ jsx(Box, {
		...useStyles({
			name: "ActionIconGroup",
			props,
			classes: ActionIcon_module_default,
			className,
			style,
			classNames,
			styles,
			unstyled,
			attributes,
			vars,
			varsResolver,
			rootSelector: "group"
		})("group"),
		variant,
		mod: [{ "data-orientation": orientation }, mod],
		role: "group",
		...others
	});
});
ActionIconGroup.classes = ActionIcon_module_default;
ActionIconGroup.varsResolver = varsResolver;
ActionIconGroup.displayName = "@mantine/core/ActionIconGroup";
//#endregion
export { ActionIconGroup };

//# sourceMappingURL=ActionIconGroup.mjs.map